import ActionPanel from '@/components/ActionPanel';
import FetchingSelect from '@/components/FetchingSelect';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { checkCountryActivitiesEmptyCity } from '@/services/activity-info.service';
import { getCountriesLookup } from '@/services/country.service';
import { toastErrorMessage, toastSuccessMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { Button, Modal} from 'rsuite';


const CheckActivitiesEmptyCityAction: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCountryId, setSelectedCountryId] = useState<number>();

  const handleRun = async () => {
    if (!selectedCountryId) return;

    setLoading(true);
    try {
      const result: BaseResponseModel<number> =
        await checkCountryActivitiesEmptyCity(selectedCountryId);

      if (result.success) {
        toastSuccessMessage(
          `Empty city activities checked successfully. Total affected activities: ${result.result}`
        );
        setOpen(false);
      }
    } catch (err) {
      const errorModel =
        (err as AxiosError<BaseErrorModel>).response?.data;

      toastErrorMessage(
        `Error checking activities missing city: ${errorModel?.errorMessage}`
      );
    } finally {
      setLoading(false);
    }
  };

    return (
      <>
        <ActionPanel
          title='Check Activities Empty City'
          description='This action will check for activities that are missing city information and attempt to update them based on available data.'
          onClick={() => setOpen(true)}
          loading={loading}
        />
        <Modal open={open} onClose={() => setOpen(false)} size="sm" backdrop="static">
          <Modal.Header>
            <Modal.Title>Check Activities Missing City</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p style={{ marginBottom: 10 }}>
              Select the country to check its activities missing city.
            </p>

            <FetchingSelect
              block
              label="Country"
              fetchData={(text, page) => getCountriesLookup(text, page)}
              value={selectedCountryId}
              onChange={dataKey => setSelectedCountryId(dataKey)}
            />
          </Modal.Body>

          <Modal.Footer>
            <Button
              appearance="primary"
              onClick={handleRun}
              loading={loading}
              disabled={!selectedCountryId}
            >
              Run
            </Button>

            <Button
              appearance="subtle"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>      
      </>
    );
};

export default CheckActivitiesEmptyCityAction;
